//Other Libs
import styled from "styled-components";

export const Styles = styled.div`
  .tableBoth:nth-child(2) {
    .date-selector {
      padding-left: 40px !important;
    }
  }
`;